export enum LetItGoType {
  flight = "flight",
  hotel = "hotel",
  car = "car",
  train = "train",
}
